import SiteDashboardPage from './SiteDashboardPage';
import { DashboardHostRouteShell } from './DashboardHostRouteShell';

// -- type definitions --

export interface ContextFreeDashboardRouteProps {
  readonly grid_id: number;
}

// -- main component --

/** Standalone dashboard entry without URL route params (e.g. home page config). */
export default function ContextFreeDashboardRoute({
  grid_id,
}: ContextFreeDashboardRouteProps) {
  return (
    <DashboardHostRouteShell
      project_id={null}
      site_id={null}
      grid_id={grid_id}
      mode="standalone"
      grid_type="grids"
      simplified_view={true}
      dashboard_only_mode={false}
    >
      <SiteDashboardPage />
    </DashboardHostRouteShell>
  );
}
